<div class="" style="padding-top: 10px">
  <div class="grid">
    <div class="col-12">
      <div style="display: flex; flex-direction: row">
        <div style="flex-grow: 1"><h2 class="sub-header-bar mb-0 mt-2">Interactions</h2></div>
        <div style="flex-shrink: 1" *ngIf="!noAdd">
          <button
            [disabled]="!organisationId"
            class="ui-button-primary"
            icon="fa ui-icon-add"
            type="button"
            pButton
            (click)="addInteraction()"
            label="Add Interaction"
          ></button>
        </div>
      </div>

      <div class="mt-2">
        <p-table
          [value]="interactions"
          [rows]="10"
          [paginator]="true"
          selectionMode="single"
          [(selection)]="selectedInteraction"
          #dt
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 24px"></th>
              <th pSortableColumn="addedByUser">Created By</th>
              <th pSortableColumn="addedDate">Created</th>
              <th pSortableColumn="interactonChannel.name">Channel</th>
              <th pSortableColumn="interactonDepartment.name">Dept</th>
              <th>Job Ref</th>
              <th pSortableColumn="note">Note</th>
              <th pSortableColumn="interactionCategory.name">Category</th>
              <th>Attachment</th>
              <th style="width: 34px"></th>
              <th style="width: 34px"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item let-i="rowIndex">
            <tr class="no-wrap-cells">
              <td style="padding: 0px !important; text-align: center">
                <div>
                  <i *ngIf="item.pinnedOrder" pTooltip="Interaction Pinned" class="material-icons"
                    >pin_drop</i
                  >
                </div>
              </td>
              <td [pTooltip]="item.addedByUser">{{ item.addedByUser }}</td>
              <td
                pTooltip="{{ item.addedDate | date : 'EEE dd MMM HH:mm' }}"
                [ngClass]="{
                  'warning-amber': item.warningLevel == 1 && i == 0,
                  'warning-red': item.warningLevel == 2 && i == 0
                }"
              >
                {{ item.addedDate | date : 'EEE dd MMM HH:mm' }}
              </td>
              <td [pTooltip]="item.interactionChannel.name">{{ item.interactionChannel.name }}</td>
              <td [pTooltip]="item.interactionDepartment.name">
                {{ item.interactionDepartment.name }}
              </td>
              <td [pTooltip]="item.jobDesc">
                <a
                  *ngIf="item.jobDesc"
                  style="
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  target="_blank"
                  href="/app/jobscreen/{{ item.jobId }}"
                >
                  {{ item.jobDesc }}
                </a>
              </td>
              <td [pTooltip]="item.note" class="note-column">
                <div tooltipStyleClass="itooltip" tooltipPosition="bottom">
                  {{ item.note }}
                </div>
              </td>
              <td [pTooltip]="item.interactionCategory.name">
                {{ item.interactionCategory.name }}
              </td>
              <td>
                <a
                  *ngIf="item.photographLocation"
                  style="
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  (click)="openPhotoPresigned(item.photographLocation)"
                >
                  <i class="material-icons">photo_camera</i>&nbsp;View
                </a>
              </td>
              <td style="text-align: center; padding: 0px !important">
                <button
                  type="button"
                  (click)="editInteraction(item)"
                  icon="fa ui-icon-mode-edit"
                  pTooltip="Edit Interaction"
                  pButton
                  style="margin-left: 0px !important; transform: scale(0.7)"
                ></button>
              </td>
              <td style="text-align: center; padding: 0px !important">
                <button
                  type="button"
                  (click)="pinInteraction(item)"
                  icon="fa fa-thumb-tack"
                  [pTooltip]="(item.pinnedOrder ? 'Unpin ' : 'Pin ') + 'Interaction'"
                  pButton
                  style="margin-left: 0px !important; transform: scale(0.7)"
                ></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div *ngIf="loading" class="grid">
        <div class="col-12" style="text-align: center; margin-top: 20px">
          <i class="fa fa-spinner fa-spin fa-2x"></i> Loading Interactions...
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  class="interaction-dialog"
  [header]="f.id.value ? 'Edit Interaction' : 'New Interaction'"
  [(visible)]="showDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '800px', 'overflow-y': 'auto' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form [formGroup]="form" (ngSubmit)="saveInteraction()" autocomplete="off">
    <div class="ui-grid ui-grid-responsive">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="addedDate">Date</label></div>
        <div class="ui-g-8">
          <p-calendar
            [showTime]="true"
            name="addedDate"
            id="addedDate"
            dateFormat="D d MM"
            hourFormat="24"
            formControlName="addedDate"
            showIcon="true"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="interactionChannel">Channel</label></div>
        <div class="ui-g-8">
          <p-dropdown
            id="interactionChannel"
            name="interactionChannel"
            [options]="channels"
            [style]="{ width: '100%' }"
            formControlName="interactionChannelId"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="jobRef">Job Reference</label></div>
        <div class="ui-g-8">
          <interaction-job-selector
            id="jobRef"
            [jobRefId]="f.jobId.value"
            [organisationId]="organisationId"
            (jobRefSelected)="onJobRefSelected($event)"
          >
          </interaction-job-selector>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="interactionCategory">Category</label></div>
        <div class="ui-g-8">
          <p-dropdown
            id="interactionCategory"
            name="interactionCategory"
            [options]="categories"
            [style]="{ width: '100%' }"
            formControlName="interactionCategoryId"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="interactionDept">Department</label></div>
        <div class="ui-g-8">
          <p-dropdown
            id="interactionDept"
            name="interactionDept"
            [options]="departments"
            [style]="{ width: '100%' }"
            formControlName="interactionDepartmentId"
          ></p-dropdown>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="note">Details</label></div>
        <div class="ui-g-8">
          <textarea
            id="note"
            [style]="{ width: '100%' }"
            pInputTextarea
            [rows]="5"
            formControlName="note"
          ></textarea>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-g-4"><label for="files">Attachment</label></div>
        <div class="ui-g-8">
          <div class="center">
            <div class="upload empty" *ngIf="files?.length == 0">
              <ngx-file-drop
                name="files"
                id="files"
                (onFileDrop)="dropped($event)"
                (onFileOver)="fileOver($event)"
                (onFileLeave)="fileLeave($event)"
                class="engineius-file-drop"
              >
                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                  <div *ngIf="savingAttachment" class="upload-file-box">
                    <i class="fa fa-spinner fa-spin fa-2x"></i> Uploading Attachment...
                  </div>
                  <div
                    *ngIf="!savingAttachment"
                    class="upload-file-box"
                    (click)="openFileSelector()"
                  >
                    <i class="fa fa-upload" aria-hidden="true"></i> Drag & drop or
                    <span class="blue-link">choose file</span> to upload
                  </div>
                </ng-template>
              </ngx-file-drop>
            </div>

            <div class="file-border" *ngIf="files?.length > 0">
              <table style="width: 100%">
                <tr
                  style="cursor: pointer"
                  *ngFor="let file of files"
                  (click)="openPhotoPresigned(file.photographLocation)"
                >
                  <td style="width: 5%">
                    <div style="margin: 4px 12px"><i class="fa fa-file-o"></i></div>
                  </td>
                  <td>
                    <div>{{ file.fileName }}</div>
                  </td>
                  <td style="text-align: center">
                    <div
                      style="color: red; cursor: pointer"
                      pTooltip="Remove attachment"
                      (click)="removeFile($event, file)"
                    >
                      <i class="fa fa-trash-o"></i>
                    </div>
                  </td>
                  <td style="text-align: center" *ngIf="file.photographLocation">
                    <div pTooltip="View attachment">
                      <i class="fa fa-eye" style="color: #0082cb" aria-hidden="true"></i>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-12">
        <div style="display: flex; flex-wrap: wrap; grid-gap: 15px; justify-content: flex-end">
          <div style="width: 68px; text-align: center; line-height: 31px">
            <span class="cancel-button" (click)="closeDialog()"> Cancel </span>
          </div>
          <div style="flex-shrink: 1">
            <button
              type="submit"
              class="green-btn"
              pButton
              icon="fa ui-icon-check"
              label="Save"
              [disabled]="(form && form.invalid) || savingAttachment"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  [(visible)]="loadingPopupPhoto || isShownPopupPhoto"
  [modal]="true"
  [responsive]="true"
  [style]="{ width: '800px', height: '700px' }"
  header="Interaction Attachment"
>
  <img *ngIf="isShownPopupPhoto" [src]="popupPhotoUrl" style="width: 100%" />
  <span *ngIf="loadingPopupPhoto"><img src="assets/images/loader.gif" /> Loading...</span>
</p-dialog>

<p-confirmDialog
  header="Confirmation"
  icon="fa fa-question-circle"
  [style]="{ width: '425px' }"
></p-confirmDialog>
